<app-recycle-chart-filters *ngIf="years"
  [years]="years"
  [collectionStreams]="collectionStreams"
  (search)="searchData($event)"
></app-recycle-chart-filters>
<mat-divider></mat-divider>
<div class="chart-container" *ngIf="data">
  <app-recycle-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [data]="data"
  ></app-recycle-bar-chart>
</div>
